import React, { useEffect } from 'react';
import { Typography } from '@icecreamsocial/components';
import queryString from 'query-string';

import { deepLinkRedirect, replaceVariables } from '../../../../utils';

/**
 * this exists out of the normal user flow.  This is templrarily being used as the redirect handler since most of the utilities for deeplinking are already housed in this app
 * we should move these utilities out and create a micro-frontend for this particular functionality in the future.  doing that now would increase the amount of build operations in our pipeline
 * which hasn't yet been fully optimized.  this only appears when this is being redirect from an email
 */
export const Deeplinker = () => {
	const { search } = window.location;
	const {
		deeplink,
		platform,
		link,
		shareTitle,
		shareMessage,
	} = queryString.parse(search);

	useEffect(() => {
		if (platform && link) {
			deepLinkRedirect({
				platform,
				link,
				message: decodeURIComponent(shareTitle as string),
				subject: decodeURIComponent(shareMessage as string),
			});
		}
	}, []);

	return deeplink ? (
		<>
			<Typography.P
				display='block !important'
				margin='auto'
				text-align='center'
			>
				If you are not redirected, please make sure you have the intended app
				already installed on your device. Some share methods are only available
				on mobile and if you have the app already installed on your device.
			</Typography.P>
			<Typography.P
				display='block !important'
				margin='auto'
				text-align='center'
			>
				You may also need to disable your popup blocker or whitelist
				"referral.icecreamsocial.io"
			</Typography.P>
		</>
	) : null;
};
